import React, { useState, useRef } from 'react';
import { personalInfo } from '../../data/portfolioData';
import emailjs from '@emailjs/browser';
import config from '../../config/config';

const ContactSection = () => {
  const form = useRef();
  const [status, setStatus] = useState('idle');
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });

  const handleChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      await emailjs.sendForm(
        config.emailJsServiceId,
        config.emailJsTemplateId,
        form.current,
        config.emailJsPublicKey
      );
      setStatus('success');
      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch {
      setStatus('error');
    }
  };

  return (
    <section className="contact-section" id="contact">
      <div className="section-header">
        <span className="section-meta">Get in Touch</span>
        <h2 className="section-title">Contact</h2>
      </div>
      <div className="contact-grid">
        <div className="contact-info">
          <div className="contact-details">
            <div className="contact-detail-item">
              <div className="contact-detail-icon"><i className="fas fa-globe"></i></div>
              <div className="contact-detail-text">
                <span>Email</span>
                <a href={`mailto:${personalInfo.email}`}>{personalInfo.email}</a>
                <a href={`mailto:${personalInfo.email2}`}>{personalInfo.email2}</a>
              </div>
            </div>
            <div className="contact-detail-item">
              <div className="contact-detail-icon"><i className="fas fa-map-marker-alt"></i></div>
              <div className="contact-detail-text">
                <span>Address</span>
                <p>12 Magpie Walk, Hatfield, UK Pin: AL108RX</p>
                <p>Ward No 6, Nichlaul Maharajganj Pin: 273304</p>
              </div>
            </div>
            <div className="contact-detail-item">
              <div className="contact-detail-icon"><i className="fas fa-phone"></i></div>
              <div className="contact-detail-text">
                <span>Phone</span>
                <a href="tel:+4407876128289">+44 7876128289</a>
                <a href="tel:+918743870503">+91 8743870503</a>
              </div>
            </div>
          </div>
        </div>

        <form ref={form} className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Your Name</label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Your Name" required />
          </div>
          <div className="form-group">
            <label>Email Address</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} placeholder="Your Email" required />
          </div>
          <div className="form-group">
            <label>Subject</label>
            <input type="text" name="subject" value={formData.subject} onChange={handleChange} placeholder="Subject" />
          </div>
          <div className="form-group">
            <label>Message</label>
            <textarea name="message" value={formData.message} onChange={handleChange} placeholder="Your Message" required />
          </div>

          {status === 'success' && (
            <div className="form-success"><i className="fas fa-check-circle" style={{ marginRight: 8 }}></i>Message sent successfully!</div>
          )}
          {status === 'error' && (
            <div className="form-success" style={{ background: 'rgba(239,68,68,0.12)', borderColor: 'rgba(239,68,68,0.3)', color: '#ef4444' }}>
              <i className="fas fa-exclamation-circle" style={{ marginRight: 8 }}></i>Failed to send. Please email directly.
            </div>
          )}

          <button type="submit" className="btn-primary form-submit" disabled={status === 'sending'}>
            {status === 'sending'
              ? <><i className="fas fa-spinner fa-spin"></i> Sending...</>
              : <><i className="fas fa-paper-plane"></i> Send Message</>
            }
          </button>
        </form>
      </div>
    </section>
  );
};

export default ContactSection;
